import React from "react";
import { translate } from "Shared/translate";
import classnames from "classnames";
import Autocompletions from "./Autocompletions";
import Icon from "Shared/Icon";
import * as searchHistory from "../../../../../Search/search-history";
import * as styles from "./field.scss";
import * as mobilestyles from "./mobile.scss";
import MyMenigoIcon from "../../../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import Spinner from "Shared/Spinner";
class QuickSearchField extends React.Component {
    constructor(props) {
        super(props);
        this.onClear = () => {
            if (this.props.searchText === "") {
                this.props.onClose();
            }
            else {
                this.props.onChange("");
                this.input.focus();
            }
        };
        this.onFocus = () => {
            if (!this.hasFocus) {
                this.props.onChange(this.props.searchText);
            }
            this.hasFocus = true;
            clearTimeout(this.blurTimer);
        };
        this.onChange = (e) => {
            const searchText = e.target.value;
            this.setState({ loadingQuickSearch: true });
            this.props.onChange(searchText).then(() => {
                this.setState({ loadingQuickSearch: false });
            });
        };
        this.onSubmit = (e) => {
            e.preventDefault();
            this.props.onSearch(this.props.searchText);
            this.input.blur(); // Needed for iOS10 to close keyboard
        };
        this.onAutocompleClick = (text) => {
            searchHistory.add(text);
        };
        this.state = {
            loadingQuickSearch: false,
        };
    }
    componentDidMount() {
        if (this.input.setSelectionRange) {
            this.input.setSelectionRange(this.props.searchText.length, this.props.searchText.length);
        }
    }
    render() {
        const { searchText, completionsLists } = this.props;
        const hasProducts = completionsLists.reduce((i, l) => i + (l.products && l.products.length ? l.products.length : 0), 0) > 0;
        return (React.createElement("form", { onSubmit: (e) => this.onSubmit(e), className: styles.base },
            React.createElement("div", { className: styles.mobileTopWrapper },
                React.createElement("div", { className: styles.searchTop },
                    React.createElement("div", { className: classnames(styles.searchInputWrapper) },
                        React.createElement("div", { className: styles.searchInputContainer },
                            React.createElement("div", { className: styles.icon },
                                React.createElement(MyMenigoIcon, { name: "search" })),
                            React.createElement("input", { className: styles.searchInput, placeholder: translate("/QuickSearch/Placeholder"), type: "search", value: this.props.searchText, onFocus: () => this.onFocus(), onChange: (e) => this.onChange(e), ref: (el) => {
                                    this.input = el;
                                }, autoFocus: true }),
                            !!this.state.loadingQuickSearch && (React.createElement(Spinner, { className: styles.smallspinner })),
                            !this.state.loadingQuickSearch &&
                                this.props.searchText.length > 0 && (React.createElement("button", { type: "button", className: mobilestyles.clear, onClick: (e) => this.onClear() },
                                React.createElement(Icon, { name: "close" })))),
                        React.createElement("button", { type: "submit", className: mobilestyles.hiddenSearchButton, style: { opacity: 0 } }),
                        React.createElement("button", { type: "button", className: styles.close, onClick: this.props.onClose },
                            React.createElement(Icon, { name: "header-close" }))))),
            React.createElement(Autocompletions, { lists: completionsLists, thinSelection: !hasProducts, searchText: searchText, onItemClick: this.onAutocompleClick })));
    }
}
export default QuickSearchField;
